<template>
  <div class="content no-flex active">
    <ed-section
      title="Invoice Information"
      class="no-flex active"
      wide
    >
      <span slot="description">
        {{description}}
      </span>
      <ed-form
        class="col-md-12"
        :submit-visible='false'
      >
        <div class="col-md-8">
          <div v-if='settings.CompanySettings.EditingInvoiceScan'>
            <div>
              <label class="control-label">Planner</label>
              <br/>
              <p>{{model.CreatedByInfo.Name}}</p>
            </div>

            <div v-if='model.CreatedByInfo.Phone'>
              <label class="control-label">Planner Phone Number</label>
              <br/>
              <p>{{model.CreatedByInfo.Phone}}</p>
            </div>

            <div>
              <label class="control-label">Planner Email Address</label>
              <br/>
              <p>{{model.CreatedByInfo.Email}}</p>
            </div>
          </div>
          <ed-select
            :field-label='programLabel'
            :placeholder='"Select a " + programLabel'
            :options='programs'
            v-model='program'
            required
            :customLabel='getProgramLabel'
            @open='fetchProgramsonOpen'
            @search='fetchPrograms'
            @close='restorePrograms'
            @select='selectProgram($event)'
            :openEndpoint='api.$.invoice.list.uploadInvoicePrograms'
            helptipHeader=''
            track-by="Key"
            :error='model.Errors.ProgramMissing || model.Errors.ProgramCancelled'
            :helptip-body='programSelectErrorMessage'
            name='programs'
          >
            <template
              slot='option'
              slot-scope='props'>
              <ed-select-options thumbnails>
                <div slot='row1' class="">
                  <span class="option-strong"> <strong >{{ he.decode(props.option.Value.ProgramName || '') }} </strong> </span>
                  <br />
                  <span v-if="props.option.Value.InternalProgramId" class="details-text">
                    {{ he.decode(props.option.Value.InternalProgramId) }}
                  </span>
                </div>
              </ed-select-options>
            </template>
          </ed-select>

          <!-- Program Budget -->
          <program-budget
            v-if="model.ProgramName"
            :title="programBudgetTitle"
            :currency="programCurrencyCode"
            :data="programBudgetData"
            :key="programBudgetData[0].join('')"
          />
          <!-- // -->

           <!-- Associated Approval Channel -->
           <div v-if="settings.CompanySettings.EditingInvoiceScan">
              <label class="control-label">
                Associated {{singularize(divisionLabel)}}
              </label>
              <br />
              <p>{{model.DivisionName}}</p>
            </div>

            <!-- Associated Bill To Address -->
            <div v-if="settings.CompanySettings.EditingInvoiceScan">
              <label class="control-label">Associated Bill To Address</label>
              <br/>
              <p>
                <span v-if="billToAddress.companyName">{{ billToAddress.companyName }}</span><br>
                <span v-if="billToAddress.address.address1">{{ billToAddress.address.address1 }}</span><br>
                <span v-if="billToAddress.address.city">{{ billToAddress.address.city }}</span><span v-if="billToAddress.address.state">, {{ billToAddress.address.state }}</span> <span v-if="billToAddress.address.zipCode">{{ billToAddress.address.zipCode }}</span>
              </p>
            </div>

          <div v-if="!userHasBothTypeOfDivisions || (userHasBothTypeOfDivisions && model.ProgramID > 0)">
            <ed-select field-label='PO'
                       placeholder='Select PO'
                       :options='purchaseOrders'
                       v-model='purchaseOrder'
                       required
                       :disabled="disablePO"
                       :customLabel='getPOLabel'
                       track-by='Key'
                       @open='fetchPOsOnOpen'
                       @search='fetchPOs'
                       @close='restorePOs'
                       @select='selectPurchaseOrder($event)'
                       :openEndpoint='api.$.invoice.i2p.purchaseOrders'
                       :error='model.Errors.POMissing'
                       :helptip-body='model.Errors.POMissing && "Please select a PO." || ""'
                       helptipHeader=''
                       name='payment_type'
                       v-if='isP2PInvoice'>
              <template slot='option'
                        slot-scope='POprops'>
                <ed-select-options thumbnails>
                  <div slot='row1' class="">
                    <span class="option-strong"> <strong>{{ he.decode(POprops.option.Value.PONumber || '') }} </strong> </span>
                    <br />
                    <span v-if="POprops.option.Value.SupplierName" class="details-text">
                      {{ he.decode(POprops.option.Value.SupplierName || '') }}
                    </span>
                    &nbsp;&nbsp; - &nbsp;&nbsp;
                    <span v-if="POprops.option.Value.CreatedDate" class="details-text">
                      {{ POprops.option.Value.CreatedDate }}
                    </span>
                  </div>
                </ed-select-options>
              </template>
            </ed-select>

            <supplier :model="model"
                      :hasOnlyP2PPrograms="userHasJustP2PDivisions"
                      :isEoadmin="settings.CompanySettings.EditingInvoiceScan"
                      @supplierSelected="onSupplierSelected"
                      @supplierRemoved="onSupplierRemoved">
            </supplier>

            <div v-if="addOutofNetworkSuppliersPermission && !isP2PInvoice">
              <div v-if="disableAddSupplier === false"
                   ref="addNewSupplierDialogContainer">
                <a href='#' @click.prevent='addNewSupplierClickHandler' name='add_new_supplier_link'>
                  <u>+ Add new supplier</u>
                </a>
              </div>
              <br />
            </div>

            <!-- Supplier Zip Code -->
            <ed-input v-model="model.SupplierZipCode"
                      field-label="Confirm Postal/Zip Code"
                      :required='model.IsRequiredSupplierZipCode'
                      :error="model.Errors.SupplierZipCodeMissing"
                      helptip-header=""
                      :helptip-body='model.Errors.SupplierZipCodeMissing && "Please fill in the Postal/Zip Code." || ""'
                      @input='handleZipCodeChange'
                      name='supplier_zip_code'>
              <p slot="additionalText" class="additional-text-no-padding">
                <em>Enter Supplier's Postal/Zip Code as listed on the supplier's invoice</em>
              </p>
            </ed-input>

            <ed-select v-if="showField('PaymentType')"
                       field-label='Payment Type'
                       placeholder='Select Payment Type'
                       :options='paymentTypes'
                       v-model='paymentType'
                       required
                       label='Value'
                       track-by='Value'
                       @open='fetchPaymentTypes'
                       @select='selectPaymentType($event)'
                       :openEndpoint='api.$.invoice.i2p.paymentTypes'
                       :error='model.Errors.PaymentTypeMissing'
                       :helptip-body='model.Errors.PaymentTypeMissing && "Please select a Payment Type." || ""'
                       helptipHeader=''
                       name='payment_type'
                       :disabled='disabledPaymentType'></ed-select>

            <ed-select v-if='showPaymentTerm'
                       field-label='Discounted Payment Terms'
                       placeholder='Select Discounted Payment Term'
                       :options='discounts'
                       v-model='discount'
                       required
                       label='Value'
                       track-by='Value'
                       @open='fetchDiscounts'
                       @select='selectDiscount($event)'
                       @remove='removeDiscount($event)'
                       :openEndpoint='api.$.invoice.i2p.discounts'
                       :error='model.Errors.DiscountMissing'
                       :helptip-body='model.Errors.DiscountMissing && "Please select a Payment Term." || ""'
                       helptipHeader=''
                       name='payment_term'
                       :disabled='disabledPaymentTerm'></ed-select>

            <ed-checkbox v-if='showSameDayDepositCheck'
                         @click='changeSameDaySetting'
                         :options='sameDayDepositOption'
                         name='same_day_deposit_check'
                         required
                         :helptip-body="sameDayDepositOption[0].label"
                         :disabled='disabledSameDayDepositCheck'>
              <p slot="additionalText" class="additional-text">
                <em>Requests made after 5pm CT will be processed the next business day</em>
              </p>
            </ed-checkbox>

            <!-- INVOICE DATE -->
            <ed-datepicker field-label='Invoice Date'
                           placeholder='Select date'
                           v-model='invoiceDate'
                           :shortcuts="getDatepickerShortcuts"
                           required
                           :disabled="this.settings.CompanySettings.EditingInvoiceScan && !this.model.IsFromEmailForScanning"
                           width=''
                           @input='selectInvoiceDate'
                           :format="dateFormat"
                           :error='model.Errors.InvoiceDateMissing || model.Errors.InvoiceDateIncomplete'
                           :helptip-body='model.Errors.InvoiceDateMissing ? "Please select an Invoice Date." : (model.Errors.InvoiceDateIncomplete ? "Please enter a complete date." : "")'
                           helptipHeader=''
                           name='invoice_date'></ed-datepicker>

            <!-- DUE DATE -->
            <ed-datepicker field-label='Due Date' placeholder='Select date'
                           v-model='dueDate'
                           required
                           :disabled="this.settings.CompanySettings.EditingInvoiceScan"
                           width=''
                           @input='selectDueDate'
                           :format="dateFormat"
                           :notBefore='this.model.InvoiceDate'
                           :error='model.Errors.DueDateMissing || model.Errors.DueDateIncomplete'
                           :helptip-body='model.Errors.DueDateMissing ? "Please select an Invoice Date." : (model.Errors.DueDateIncomplete ? "Please enter a complete date." : "")'
                           helptipHeader=''
                           name='due_date'>
              <p class='text-danger' slot='info' v-if='this.model.HasRushPayment'>
                <span>Rush Payment - {{this.rushDays.RushPaymentTermsDays}} Day Payment Term</span>
                <br />
                <span>{{this.rushDays.DaysEarlier}} earlier than the {{this.rushDays.HasDiscountedPaymentTerm ? 'discounted' : 'standard'}} {{this.rushDays.StandardRushPaymentDays}}-day payment term</span>
              </p>
            </ed-datepicker>

            <div ref="requestRushPaymentDialogContainer">
            </div>

            <!-- Supplier Invoice No -->
            <ed-input v-if="this.getInvoiceId !== '0' || !this.settings.CompanySettings.AllowInvoiceScanning || isP2PInvoice"
                      v-model="model.ReferenceNo"
                      field-label="Supplier Invoice Number"
                      :required="this.getInvoiceId !== '0' || !this.settings.CompanySettings.AllowInvoiceScanning || isP2PInvoice ? model.ReferenceNoIsRequired : model.ReferenceNoIsRequired = false"
                      :error="this.getInvoiceId !== '0' || !this.settings.CompanySettings.AllowInvoiceScanning || isP2PInvoice ? model.Errors.ReferenceNoMissing : model.Errors.ReferenceNoMissing = false"
                      helptip-header=""
                      :helptip-body='model.Errors.ReferenceNoMissing && "Please fill in a Supplier Invoice Number." || ""'
                      @input='model.Errors.ReferenceNoMissing = false'
                      name='reference_no' />

            <!-- Currency -->
            <ed-select field-label='Invoice Currency' placeholder='Select a currency'
                       :options='currencies'
                       v-model='currency'
                       label='Value'
                       track-by='Value'
                       required
                       @select='selectCurrency($event)'
                       @input='currencyInput'
                       @open='fetchCurrencies'
                       :openEndpoint='api.$.invoice.i2p.currencies'
                       :error='model.Errors.InvoiceCurrencyMissing'
                       :disabled="isP2PInvoice"
                       :hidden="isP2PInvoice"
                       :helptip-body='model.Errors.InvoiceCurrencyMissing && "Please select an Invoice Currency." || ""'
                       helptipHeader=''
                       name='invoice_currency'></ed-select>

            <!-- Invoice Amount -->
            <ed-input @change="changeInvoiceAmount"
                      :field-label='invoiceAmountLabel'
                      v-model="model.InvoiceAmount"
                      required
                      amount
                      autoselect
                      type="money"
                      :currency='model.CurrencyCode'
                      :error='invoiceError'
                      :helptipHeader='invoiceAmountHelptipHeader'
                      name='invoice_amount'
                      :disabled='disableAmounts || isP2PInvoiceWithAddTaxesAndEditItems'
                      :key='model.ProgramID'
                      :conditionalText='amountConditionalPlaceholder'
                      v-if='useHighLevelAllocation || isP2PInvoice'>
              <span slot="message" v-if="invoiceError">
                {{ invoiceAmountHelptipBody }}
                <v-money v-if="invoiceAmountHelptipBody && this.model.Errors.InvoiceAmountOutOfRange"
                         class="solid"
                         :currency='model.CurrencyCode'>
                  {{ templateNotInvoicedAmount }}
                </v-money>
              </span>
            </ed-input>

            <ed-input @change="changeInitialTotalAmount"
                      field-label='Invoice Amount (Including VAT/GST if applicable)'
                      v-model="model.InitialTotalAmount"
                      required
                      amount
                      autoselect
                      type="money"
                      :currency='model.CurrencyCode'
                      :error='invoiceError'
                      :helptipHeader='invoiceAmountHelptipHeader'
                      name='invoice_initial_amount'
                      :disabled='disableAmounts'
                      :conditionalText='amountConditionalPlaceholder'
                      v-if='showNeddedFieldsForScanning || model.IsScanning'>
              <span slot="message" v-if="invoiceError">
                {{ invoiceAmountHelptipBody }}
              </span>
            </ed-input>

            <ed-input v-if='(useHighLevelAllocation && settings.CompanySettings.AllocateVAT && !isP2PInvoice) || isVatGstRequired'
                      @change="changeVatGSTAmount"
                      field-label="VAT/GST"
                      v-model="model.VATGSTAmount"
                      :required="isVatGstRequired"
                      amount
                      autoselect
                      type="money"
                      :currency='model.CurrencyCode'
                      name='vat_gst_amount'
                      :disabled='disableAmounts'
                      :key='model.ProgramID'
                      :conditionalText='amountConditionalPlaceholder' />

            <ed-checkbox @click='changeReimbursementSetting'
                         :options='reimbursementOption'
                         name='reimbursement_check'
                         required
                         :helptip-body="reimbursementOption[0].label">
              <p slot="additionalText" class="additional-text">
                <em>Please check this box if this invoice is a reimbursement for a business expense. By checking this box, we will not include these amounts in the supplier's 1099.</em>
              </p>
            </ed-checkbox>

            <ed-upload :class='{loading: !uploadFinished}'
                       :field-label=uploadFieldName
                       button-label='Browse'
                       v-model='attachedFiles'
                       :canOpenFile="settings.CompanySettings.EditingInvoiceScan"
                       readonly
                       :multiple='true'
                       :postAction='api.env + api.$.upload.uploadInvoice'
                       :uploadAuto='true'
                       :data='uploadData'
                       :required='settings.CompanySettings.RequireAttachment'
                       @input='createAttachments'
                       :error='model.Errors.AttachmentsMissing'
                       :showHelptipIcon='false'
                       :helptip-body='model.Errors.AttachmentsMissing && "Please attach at least one PDF file." || ""'
                       helptipHeader=''
                       name='attachment_upload'
                       :noButton="settings.CompanySettings.EditingInvoiceScan">
              <p slot='additionalText' class="additional-text text-red">
                <em>All files attached here will be visible to the supplier. To attach internal documents, use "Comments & Attachments".</em>
              </p>
            </ed-upload>

            <allocation-section v-if='showNeddedFieldsForScanning'
                                :model="model"
                                :error='model.Errors.AllocationTypeMissing'
                                :helptip-body='model.Errors.AllocationTypeMissing && "Please select an Allocation Type." || ""'
                                @allocationForScanSelected='onSelectAllocationType'
                                :displayAllocationError='model.Errors.AllocationMissing'
                                name='allocation_section'
                                :key="model.ProgramID"></allocation-section>

            <ed-textarea v-if='settings.CompanySettings.EditingInvoiceScan === false'
                         field-label="Description"
                         placeholder="Description"
                         v-model="model.Description"
                         :rows="5"
                         @input="onDescriptionChanged"
                         name='scan_description_textarea'>
            </ed-textarea>

            <div v-if="settings.CompanySettings.EditingInvoiceScan && model.Description">
              <label>Description</label><br />
              <p>{{getDescription}}</p>
              <br />
            </div>

            <custom-fields v-if="model.DivisionID > 0"
                           :endpoint="api.$.invoice.i2p.customFields"
                           :queryParameters="{invoiceId: model.PaymentInvoiceId, divisionId: model.DivisionID, businessUnitId: (purchaseOrderFromInitParsed && purchaseOrderFromInitParsed.events[0].lineItems[0] && purchaseOrderFromInitParsed.events[0].lineItems[0].costCenterAndBusinessUnit.businessUnitId) || model.BusinessUnitID}"
                           @loaded="onCustomFieldsLoad"
                           ref="customFieldsRef"
                           :key="cFields">
            </custom-fields>

          </div>

          <ed-modal
            :show='showUploadError'
            @close='cloneUploadError()'
            @confirm='cloneUploadError()'
            title='Errors'
            primaryButton='Ok'
            type='medium'
            name='show_upload_error'
            >
              <div slot="body">
                <p
                  v-for='message in errorMessages'
                  :key='message'>
                  {{message}}
                </p>
              </div>
          </ed-modal>

          <ed-modal
            :show='showConfirmProgramSelected'
            @close='changeToPreviousProgram()'
            @confirm='changeProgram(program)'
            title=''
            :subtitle='changeProgramMessage'
            primaryButton='Ok'
            secondaryButton='Cancel'
            type='medium'
            name='confirm_program_selected'
          ></ed-modal>

           <ed-modal
            :show='showDiscountDueDateValidationError'
            @close='showDiscountDueDateValidationError=false'
            title=''
            primaryButton='false'
            secondaryButton='Ok'
            type='medium'
          >
            <div slot="body">
              <p><br>You cannot set the due date {{ getDueDateDifferenceInDays }} days after the invoice date, due to the discounted payment terms that you selected for this invoice. In order to set this due date, you need to change the discounted payment terms for this invoice.</p>
            </div>
          </ed-modal>

           <ed-modal
            :show='model.Errors.InvoiceAmountExceededPOThreshold'
            @close='model.Errors.InvoiceAmountExceededPOThreshold=false'
            title=''
            primaryButton='false'
            secondaryButton='Ok'
            type='medium'
          >
            <div slot="body">
              <p><br>The total amount invoiced for this PO cannot exceed the total amount of the PO.</p>
            </div>
          </ed-modal>

        </div>
      </ed-form>
      <div class="clear"></div>
    </ed-section>
  </div>
</template>


<script>

import supplier from './Supplier.vue'
import InviteSupplier from './dialogs/InviteSupplierDialog.vue'
import AddEditSupplierOld from './dialogs/AddEditSupplier.vue'
import RequestRushPayment from './RequestRushPayment.vue'
import allocationSection from './AllocationSection.vue'
import ProgramBudget from './components/programBudget'

import Vue from 'vue'
import { Eved, EventBus } from '@/event-bus'
import Events from '@/core/events/events'

import customFields from '@/core/components/Form/customFields.vue'

import Api from './api'
let api = new Api()

// import debounce from 'lodash/debounce'
import he from 'he'

import programConstants from './models/program-constants'

const eventHub = new Vue()

const FIELDS = {
  SupplierInvoiceNumber: 'SupplierInvoiceNumber'
}

export default {
  name: 'invoiceInformation',

  props: {
    model: Object,
    divisionLabel: String,
    purchaseOrderForBillTo: String,
    settings: Object,
    user: Object,
    useHighLevelAllocation: Boolean,
    maxInvoiceAmount: Number,
    initialInvoiceAmount: [Number, String]
  },

  components: {
    supplier,
    allocationSection,
    ProgramBudget,
    customFields
  },

  created() {
    EventBus.$off(Eved.I2P.MAP_INVOICE_INFORMATION_FIELDS)
    EventBus.$on(Eved.I2P.MAP_INVOICE_INFORMATION_FIELDS, e => {
      this.mapExistingItems()
    })

    EventBus.$off(Eved.I2P.MAP_DEFAULT_PAYMENT_TYPE_DISCOUNT)
    EventBus.$on(Eved.I2P.MAP_DEFAULT_PAYMENT_TYPE_DISCOUNT, e => {
      this.mapExistingPaymentTypeAndDiscount(e)
    })

    EventBus.$off('disableSupplier')
    EventBus.$on('disableSupplier', this.disableSupplier)

    EventBus.$off('closeRushPayment')
    EventBus.$on('closeRushPayment', this.onCloseRushPaymentDialog)

    EventBus.$off('saveRushPayment')
    EventBus.$on('saveRushPayment', this.onSaveRushPaymentDialog)

    EventBus.$off(Eved.I2P.CONFIRM_PROGRAM_SELECTED)
    EventBus.$on(Eved.I2P.CONFIRM_PROGRAM_SELECTED, this.confirmProgramSelected)

    EventBus.$off(Eved.I2P.PO_AMOUNT_CHANGED)
    EventBus.$on(Eved.I2P.PO_AMOUNT_CHANGED, this.onPOAmountChanged)

    EventBus.$off(Eved.I2P.UPDATE_PO_MODEL_COMPLETED)
    EventBus.$on(Eved.I2P.UPDATE_PO_MODEL_COMPLETED, this.continueSelectPurchaseOrder)

    this.he = he

    this.purchaseOrderFromInitParsed = this.parsePO(this.purchaseOrderForBillTo)
  },

  data () {
    return {
      FIELDS,
      title: '',

      attachedFiles: null,

      program: null,
      previousProgram: {},
      previousInvoiceWorkflow: '',
      programDetails: null,
      programs: [],
      originalPrograms: [],
      showConfirmProgramSelected: false,
      programCurrencyCode: 'USD',

      paymentType: null,
      paymentTypes: [],

      discount: null,
      discounts: [{
        key: 0,
        value: 'No Discount',
        name: 'No Discount',
        daysNo: 0
      }],

      currency: null,
      currencies: [],

      puchaseOrder: null,

      invoiceDate: this.model.InvoiceDate ? this.setDate(this.model.InvoiceDate) : this.model.InvoiceDate,
      dueDate: this.model.InvoiceDate ? this.setDueDate(this.model.InvoiceDate, this.paymentTermsDays) : this.model.DueDate,

      disableAddSupplier: false,
      addOutofNetworkSuppliersPermission: this.user.hasAddOutofNetworkSuppliersPerm,
      dateFormat: this.user.dateFormat,
      paymentTermsDays: this.settings.CompanySettings.DaysNo,
      uploadData: {
        token: this.user.token
      },
      oneDay: 24 * 60 * 60 * 1000, // hours*minutes*seconds*milliseconds
      rushDays: {
        RushPaymentTermsDays: null,
        StandardRushPaymentDays: null,
        DaysEarlier: null,
        HasDiscountedPaymentTerm: false
      },
      showUploadError: false,
      uploadFinished: true,
      errorMessages: [],
      purchaseOrder: null,
      purchaseOrderFromInitParsed: this.parsePO(this.purchaseOrderForBillTo),
      purchaseOrders: [],
      originalPurchaseOrders: [],
      notInvoicedAmount: null,
      templateNotInvoicedAmount: null,
      invoiceAmountHelptipHeader: '',
      P2PisNotMapped: true,
      sameDayDepositOption: [
        {
          label: utils.constants.invoice.SameDayLabel + ' Deposit Payment Requested',
          status: this.model.IsSameDayDeposit
        }
      ],
      reimbursementOption: [
        {
          label: 'Is this a reimbursement?',
          status: this.model.IsReimbursement
        }
      ],
      disabledSameDayDepositCheck: this.model.isEditInit && this.model.TotalPaidAmount !== 0,
      disabledPaymentType: this.model.isEditInit && this.model.IsSameDayDeposit && this.model.TotalPaidAmount !== 0,
      showDiscountDueDateValidationError: false,
      dueDateToValidate: null,
      isInitSupplier: false,
      programLabel: global.app.$user.sessionSettings.CompanySettings.ProgramLabel,
      selectedPO: {},
      programBudgetData: [[]],
      customFieldsLoaded: false,
      cFields: 0,
      excludeVATFromBudget: null
    }
  },

  computed: {
    billToAddress() {
      if (this.purchaseOrderFromInitParsed) {
        return this.purchaseOrderFromInitParsed.billTo
      }
    },

    programBudgetTitle() {
      return this.programLabel + ' Budget' // Program Budget
    },

    // SPRT-18874: the cancelled block wins over "please select" — a program IS selected, it just cannot
    // be invoiced against.
    programSelectErrorMessage() {
      if (this.model.Errors.ProgramCancelled) return programConstants.cancelledProgramMessage
      if (this.model.Errors.ProgramMissing) return 'Please select a ' + this.programLabel + '.'

      return ''
    },

    changeProgramMessage() {
      return this.useHighLevelAllocation
        ? 'Changing the ' + this.programLabel + ' will delete all the allocations you have built in this invoice. Are you sure you want to change the ' + this.programLabel.toLowerCase() + '?'
        : 'Changing the ' + this.programLabel + ' will delete all the line items you have built in this invoice. Are you sure you want to change the ' + this.programLabel.toLowerCase() + '?'
    },

    getDatepickerShortcuts() {
      return !this.settings.CompanySettings.EditingInvoiceScan
        ? [
          { key: 'today', label: 'Today' },
          { key: 'yesterday', label: 'Yesterday' }
        ]
        : []
    },

    currencySelected() {
      return this.currency && this.currency.Value !== '' && this.currency.Key !== 0
    },

    purchaseOrderSelected() {
      return !(this.model.InvoiceWorkflow && this.model.InvoiceWorkflow.indexOf('P2PInvoice') !== -1) ||
        (this.purchaseOrder && !isNaN(parseInt(this.purchaseOrder.Key)))
    },

    disableAmounts() {
      return !this.currencySelected || !this.purchaseOrderSelected
    },

    isP2PInvoiceWithAddTaxesAndEditItems() {
      return this.isP2PInvoice && this.settings.CompanySettings.AllowEditItem
    },

    userHasBothTypeOfDivisions() {
      return this.user.workflowTypeStatus === 'Both'
    },

    amountConditionalPlaceholder() {
      if (!this.disableAmounts) {
        return ''
      } else {
        return this.isP2PInvoice
        ? 'Please select PO first'
        : 'Please select Invoice Currency first'
      }
    },

    isP2PInvoice() {
      return (this.model.InvoiceWorkflow && this.model.InvoiceWorkflow.indexOf('P2PInvoice') !== -1) || this.userHasJustP2PDivisions
    },

    // use instead of this.useHighLevelAllocation
    isHighLevelAllocation() {
      return this.model.InvoiceWorkflow && this.model.InvoiceWorkflow.indexOf('I2PWithHighLevelAllocation') !== -1
    },

    userHasJustP2PDivisions() {
      return this.user.WorkflowTypeStatus === '' /* Only P2P divisions */
    },

    invoiceAmountHelptipBody() {
      if (this.model.Errors.InvoiceAmountMissing || this.model.Errors.InitialTotalAmountMissing) {
        return 'Please fill in an Invoice Amount.'
      } else {
        if (this.model.Errors.InvoiceAmountOutOfRange) {
          if (this.notInvoicedAmount === 0) {
            this.templateNotInvoicedAmount = this.maxInvoiceAmount
            if (this.templateNotInvoicedAmount >= 0) {
              return 'Invoice Amount must be less than: '
            } else {
              return 'Invoice Amount must be greater than: '
            }
          } else if (this.notInvoicedAmount > 0) {
            if (this.model.InvoiceAmount > this.maxInvoiceAmount) {
              this.templateNotInvoicedAmount = this.maxInvoiceAmount
              return 'Invoice Amount must be less than: '
            }
            if (this.model.InvoiceAmount < 0) {
              this.templateNotInvoicedAmount = 0
              return 'Invoice Amount must be greater than: '
            }
          } else if (this.notInvoicedAmount < 0) {
            if (this.model.InvoiceAmount > 0) {
              this.templateNotInvoicedAmount = 0
              return 'Invoice Amount must be less than: '
            }
            if (this.model.InvoiceAmount < this.maxInvoiceAmount) {
              this.templateNotInvoicedAmount = this.maxInvoiceAmount
              return 'Invoice Amount must be greater than: '
            }
          }
        } else {
          if (this.model.Errors.InvoiceAmountNegative) {
            return 'Negative amounts are not allowed for ' + utils.constants.invoice.SameDayLabel.toLowerCase() + ' deposit invoices.'
          }
        }
      }

      return ''
    },

    invoiceAmountLabel() {
      return 'Invoice Amount (Including VAT/GST if applicable)'
    },

    invoiceError() {
      return this.model.Errors.InvoiceAmountOutOfRange ||
      this.model.Errors.InvoiceAmountMissing ||
      this.model.Errors.InvoiceAmountNegative ||
      this.model.Errors.InitialTotalAmountMissing
    },

    disablePO() {
      return this.isP2PInvoice && this.model.POid > 0 &&
        (this.invoiceIsSaved() || this.getInvoiceId > 0 ||
        this.$route.query.fusionPoId > 0)
    },
    showSameDayDepositCheck() {
      return this.settings.CompanySettings.AllowSameDayDeposit
    },
    sameDayText() {
      return this.model.IsSameDayDeposit
            ? utils.constants.invoice.SameDayLabel + ' '
            : ''
    },

    getInvoiceId() {
      return this.$route.query.invoiceId
    },
    showNeddedFieldsForScanning() {
      return !this.isHighLevelAllocation && !this.isP2PInvoice &&
            this.settings.CompanySettings.AllowInvoiceScanning === true &&
            this.settings.CompanySettings.EditingInvoiceScan === false &&
            (this.isCreateInvoice() || this.model.IsDraft)
    },
    isVatGstRequired() {
      return this.showNeddedFieldsForScanning && this.excludeVATFromBudget === true
    },
    showAllocationSection() {
      return this.useHighLevelAllocation === false && this.settings.CompanySettings.AllowInvoiceScanning === true
    },

    description() {
      let defaultMessage = `Specify your supplier's invoice information below and click Submit when complete.`

      if (this.settings.CompanySettings.EditingInvoiceScan) {
        defaultMessage = 'The planner entered this information when submitting the invoice.'
      }

      if (this.settings.CompanySettings.AllowInvoiceScanning &&
        this.model.ProgramID > 0 &&
        !this.isP2PInvoice &&
        !this.useHighLevelAllocation) {
        defaultMessage += ` The line items from the upload will be captured and processed within 1 business day, ` +
          `and you will receive an email when the invoice is ready for approval.`
      }

      return defaultMessage
    },

    uploadFieldName() {
      return this.settings.CompanySettings.EditingInvoiceScan ? 'Supplier Invoice' : 'Attach Invoice'
    },

    showPaymentTerm() {
      return this.settings.CompanySettings.UseDiscounts && !this.useHighLevelAllocation &&
        (!this.isP2PInvoice || (this.isP2PInvoice && this.model.DiscountPaymentTermID > 0))
    },

    disabledPaymentTerm() {
      return this.isP2PInvoice || (this.model.isEditInit && this.model.TotalPaidAmount !== 0)
    },

    getDueDateDifferenceInDays() {
      if (this.dueDateToValidate !== null) {
        return this.getDatesDifferenceInDays(this.model.InvoiceDate, this.dueDateToValidate)
      }
      return 0
    },

    getDescription() {
      return this.model.Description || 'None'
    },

    showField() {
      return name => this.customFieldsLoaded && !this.$refs.customFieldsRef.hideField(name)
    }
  },

  methods: {
    parsePO(purchaseOrderForBillTo) {
      if (!purchaseOrderForBillTo) {
        return ''
      }
      return JSON.parse(purchaseOrderForBillTo)
    },

    singularize(value) {
      return value.endsWith('s') ? value.slice(0, -1) : value
    },

    handleZipCodeChange() {
      this.model.Errors.SupplierZipCodeMissing = false

      this.$emit('supplier-zip-code-changed', this.model.SupplierZipCode)
    },

    onDescriptionChanged(e) {
      this.$nextTick(() => {
        this.model.Description = e
      })
    },

    createAttachments(e) {
      let completedFiles = e.filter(
        item => item.success || // files uploaded with success
        (!item.success && item.response && typeof item.response === 'string' && !this.isJson(item.response)) // files where requested failed
      )

      if (completedFiles.length >= 1) {
        this.model.Errors.AttachmentsMissing = false
      }

      if (completedFiles.length === e.length) {
        this.uploadFinished = true

        let attachments = e.map(item => {
          let uploadError = ''
          let itemResponse = null

          if (item.success && item.response) {
            itemResponse = JSON.parse(item.response)
            uploadError = (itemResponse && itemResponse.uploadError) ? itemResponse.uploadError : ''
          }
          if (!item.success) {
            uploadError = 'Upload request failed'
          }

          if (uploadError) {
            this.errorMessages.push('File "' + item.name + '": ' + uploadError)
          } else {
            return {
              AttachmentName: item.name,
              AttachmentSize: item.size,
              AttachmentFile: itemResponse ? itemResponse.file : (item.file || ''),
              AttachmentId: item.id || 0,
              AttachmentPath: itemResponse ? itemResponse.path : '',
              ReadOnly: item.readonly || false
            }
          }
        })

        this.showUploadError = this.errorMessages.length > 0

        try {
          this.attachedFiles = this.attachedFiles.filter(item =>
            item.success &&
            (
              (!item.response && item.name) || // take existing items from edit
              (JSON.parse(item.response).success) // take new added items
            )
          )
        } catch (ee) {
          console.log(ee)
        }
        attachments = attachments.filter(item => item)

        this.model.Attachments = attachments.map(item => {
          if (isNaN(item.AttachmentId)) {
            item.AttachmentId = 0
          }
          return item
        })
      } else {
        this.uploadFinished = false
      }
    },

    isJson(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },

    cloneUploadError() {
      this.showUploadError = false
      this.errorMessages = []
    },

    setDate(date) {
      var d = new Date(date)
      // WFSPRT-634: timezone fix
      if (global.moment(date).format('MM/DD/YYYY') !== global.moment(d).format('MM/DD/YYYY') &&
        d.getTimezoneOffset() !== 0) {
        d = new Date(d.getTime() + d.getTimezoneOffset() * 60000)
      }
      return d
    },

    onSupplierSelected(e) {
      // on init due date should not be changed
      this.isInitSupplier = e.IsInitSupplier || false

      this.updateDueDateOnSelectSupplier(e.SupplierInfoVM.SupplierId)

      this.setDiscountWithDefaultFromSupplier(e.SupplierInfoVM)

      if (this.showSameDayDepositCheck) {
        this.resetSameDayDepositOption(!this.model.IsDraft && typeof this.model.IsSameDayDeposit !== 'undefined'
          ? this.model.IsSameDayDeposit
          : e.SupplierInfoVM.Supplier.HasDefaultImmediatePayment)
      }

      // reset
      this.isInitSupplier = false

      // pass event to parent
      this.$emit('supplierSelected', e)
    },

    setEmptyDiscount() {
      this.discount = {
        Key: 0,
        Value: 'No Discount',
        Name: 'No Discount',
        DaysNo: this.settings.CompanySettings.DefaultDaysNo
      }
    },

    setDiscountWithDefaultFromSupplier(info) {
      if (info.DiscountPaymentTermID > 0) {
        this.discount = {
          Key: info.DiscountPaymentTermID,
          Value: info.DiscountDisplayName,
          Name: info.DiscountName,
          DaysNo: info.DaysNo
        }
      } else {
        this.setEmptyDiscount()
      }
      this.updateDiscountAndDueDate(this.discount.Key, this.discount.Name, this.discount.DaysNo, true)
    },

    onSupplierRemoved(e) {
      this.paymentTermsDays = this.settings.CompanySettings.DefaultDaysNo
      this.setEmptyDiscount()
      this.updateDueDate(this.model.InvoiceDate, this.paymentTermsDays)
      this.resetSameDayDepositOption()

      // pass data to parent (index.vue)
      this.$emit('supplierRemoved', e)
    },

    disableSupplier(e) {
      this.disableAddSupplier = e.data
    },

    isCreateInvoice() {
      return parseInt(this.$route.query.invoiceId) <= 0 ||
        isNaN(parseInt(this.$route.query.invoiceId))
    },

    mapExistingItems() {
      this.notInvoicedAmount = this.model.NotInvoicedAmount

      this.mapExistingProgram()
      this.mapExistingCurrency()
      this.mapExistingPaymentType()
      this.mapExistingDiscount()
      this.mapExistingDateFields()
      this.mapExistingAttachments()
      if (this.isP2PInvoice) {
        this.mapExistingPOs()
      }
    },

    mapExistingPaymentTypeAndDiscount(e) {
      if (e && e.data) {
        this.paymentTypes = e.data.paymentTypes
        this.discounts = e.data.discounts
      }
      this.mapExistingPaymentType()
      this.mapExistingDiscount()
    },

    mapExistingProgram() {
      if (this.model) {
        this.program = {
          Key: this.model.ProgramID,
          Value: {
            ProgramName: he.decode(this.model.ProgramName),
            InternalProgramId: this.model.InternalProgramId ? he.decode(this.model.InternalProgramId) : '',
            DivisionId: this.model.DivisionID
          }
        }

        this.programCurrencyCode = this.model.ProgramCurrencyCode
        this.loadRemainingProgramBudget(this.model.ProgramID)

        if (this.isP2PInvoice) {
          if (this.model.POid > 0) {
            this.P2PisNotMapped = false
          } else if (this.P2PisNotMapped) {
            this.getPOS(true, this.model.POid)
          }
        } else if (this.isCreateInvoice() && this.model.ProgramID) {
          this.fetchCurrencies()
        }
        this.setAllocationSectionModel(this.model.ProgramID)
      }
    },

    mapExistingPOs() {
      if (this.model) {
        this.purchaseOrder = {
          Key: this.model.POid,
          Value: {
            PONumber: this.model.PONumber,
            SupplierName: this.model.SupplierName,
            CreatedDate: this.model.POCreatedDate
              ? global.moment(this.model.POCreatedDate).format(this.dateFormat)
              : ''
          }
        }
      }
    },

    mapExistingCurrency() {
      if (this.isCreateInvoice() && !this.isP2PInvoice) {
        this.currency = {
          Key: 0,
          Value: null
        }
      } else {
        this.mapSelectedCurrency()
      }
    },

    mapSelectedCurrency() {
      if (this.model) {
        this.currency = {
          Key: this.model.CurrencyID,
          Value: this.model.CurrencyName,
          Symbol: this.model.CurrencySymbol,
          DecimalPlaces: this.model.CurrencyDecimalPlaces
        }
      }
    },

    mapExistingPaymentType() {
      if (this.model) {
        this.paymentType = {
          Key: this.model.PaymentTypeID,
          Value: this.model.PaymentType
        }
      }
    },

    mapExistingDiscount() {
      if (this.model) {
        this.discount = {
          Key: this.model.DiscountPaymentTermID,
          Value: this.model.DiscountDisplayName,
          Name: this.model.DiscountName,
          DaysNo: this.settings.CompanySettings.DaysNo
        }
      }
    },

    mapExistingDateFields() {
      if (this.model) {
        this.isCreateInvoice() && !this.model.isEditInit && this.selectInvoiceDate(this.model.InvoiceDate)
        this.selectDueDate(this.model.DueDate)
        EventBus.$emit(Eved.I2P.DUE_DATE_COMPUTED_ON_INIT, {
          dueDate: this.model.DueDate
        })
      }
    },

    mapExistingAttachments() {
      if (this.model && this.model.Attachments) {
        let attachments = []
        for (var f in this.model.Attachments) {
          if (this.model.Attachments.hasOwnProperty(f)) {
            let entry = this.model.Attachments[f]
            attachments.push({
              fileObject: true,
              id: entry.AttachmentId,
              name: entry.AttachmentName,
              file: entry.AttachmentFile,
              path: entry.AttachmentPath,
              type: entry.AttachmentType,
              size: entry.AttachmentSize,
              readonly: entry.ReadOnly,
              success: true
            })
          }
        }
        this.attachedFiles = attachments
      }
    },

    fetchProgramsonOpen() {
      this.programs.length || this.api.forms.post(this.api.$.invoice.list.uploadInvoicePrograms, {
        q: '',
        onlyI2PInvoices: false,
        invoiceId: this.getInvoiceId

      })
        .then(r => {
          if (r && r.data && r.data.Data) {
            var parsedPrograms = this.splitProgramDetails(r.data.Data)

            this.programs = parsedPrograms
            this.originalPrograms = utils.copy(parsedPrograms)
          }
        })
        .catch(e => console.warn(e))
    },

    splitProgramDetails(programsWithDetails) {
      var newPrograms = []

      programsWithDetails.map(program => {
        var elements = program.Value.split('##')
        var newProgram = {
          Key: program.Key,
          Value: {
            ProgramName: elements[0],
            InternalProgramId: elements[1] ? elements[1] : ''
          }
        }
        newPrograms.push(newProgram)
      })

      return newPrograms
    },

    fetchPOsOnOpen() {
      this.purchaseOrders.length || this.getPOS()
    },

    getPOS(getPOSWhenProgramSelected, POId) {
      this.api.forms.post(this.api.$.invoice.i2p.purchaseOrders, {
        q: '',
        programId: this.model.ProgramID,
        invoiceId: this.getInvoiceId
      })
        .then(r => {
          if (r && r.data && r.data.Data) {
            var parsedPOs = this.populatePOsInfo(r.data.Data)
            this.purchaseOrders = parsedPOs
            this.originalPurchaseOrders = utils.copy(parsedPOs)

            if (getPOSWhenProgramSelected) {
              if (this.purchaseOrders.length === 1) {
                this.purchaseOrder = utils.copy(this.purchaseOrders[0])
              } else {
                if (POId) {
                  let poSelected = this.purchaseOrders.filter(item => item.Key === (-1) * Number(POId))[0]
                  this.purchaseOrder = utils.copy(poSelected)
                }
              }

              if (this.purchaseOrder && this.purchaseOrder.Key) {
                this.selectPurchaseOrder(this.purchaseOrder)
              }

              this.P2PisNotMapped = false
            }
          }
        })
        .catch(e => console.warn(e))
    },

    populatePOsInfo(POsWithDetails) {
      var newPurchaseOrders = []

      POsWithDetails.map(po => {
        var newPO = {
          Key: po.POId,
          Value: {
            ProgramId: po.ProgramId,
            PONumber: po.PONumber,
            SupplierName: po.SupplierName,
            SupplierEmail: po.SupplierEmail,
            SupplierId: po.SupplierId,
            SupplierContactName: po.SupplierContactName,
            SupplierPhoneNumber: po.SupplierPhoneNumber,
            CreatedDate: global.moment(po.CreatedDate).format(this.dateFormat),
            NotInvoicedAmount: po.NotInvoicedAmount,
            CurrencyID: po.CurrencyID,
            CurrencyName: po.CurrencyName,
            CurrencyNameFormatted: po.CurrencyNameFormatted,
            CurrencySymbol: po.CurrencySymbol,
            DecimalPlaces: po.DecimalPlaces,
            POMasterId: po.POMasterId,
            POId: po.POId,
            IsSavingsPO: po.IsSavingsPO
          }
        }

        newPurchaseOrders.push(newPO)
      })

      return newPurchaseOrders
    },

    async fetchPrograms(query) {
      let results = await this.api.forms.post(this.api.$.invoice.list.uploadInvoicePrograms, {
        q: query || '',
        onlyI2PInvoices: false,
        invoiceId: this.getInvoiceId
      })

      if (results && results.data && results.data.Data) {
        this.programs = this.splitProgramDetails(results.data.Data)
      }
    },

    async fetchPOs(query) {
      let results = await this.api.forms.post(this.api.$.invoice.i2p.purchaseOrders, {
        q: query || '',
        programId: this.model.ProgramID,
        invoiceId: this.getInvoiceId
      })

      if (results && results.data && results.data.Data) {
        this.purchaseOrders = this.populatePOsInfo(results.data.Data)
      }
    },

    restorePrograms() {
      this.programs = utils.copy(this.originalPrograms)
    },

    restorePOs() {
      this.purchaseOrders = utils.copy(this.originalPurchaseOrders)
    },

    selectProgram(e) {
      this.$emit(Eved.I2P.BEFORE_PROGRAM_SELECTED, e)
    },

    confirmProgramSelected(e) {
      if (e.data.canSelectProgram) {
        // update program on PO
        this.changeProgram(e.data.program)
      } else {
        // confirm the program can be changed
        this.showConfirmProgramSelected = true
      }
    },

    onPOAmountChanged(e) {
      if (this.isP2PInvoice && this.settings.CompanySettings.AllowEditItem) {
        this.model.InvoiceAmount = +e.data.total

        this.$emit(Events.I2P.PO_AMOUNT_CHANGED, {
          total: this.model.InvoiceAmount
        })
      }
    },

    changeProgram(program) {
      this.setInitialProgramData(program)
      this.resetAmountsOnPrgChanged()
      this.getProgramDetails(program.Key)

      this.changeInvoiceAmount()
      this.changeVatGSTAmount()
      this.fetchCurrencies()
      this.mapExistingPaymentTypeAndDiscount()
    },

    setInitialProgramData(program) {
      this.previousProgram = program
      this.previousInvoiceWorkflow = this.model.InvoiceWorkflow

      this.model.ProgramID = program.Key
      this.model.ProgramName = program.Value.ProgramName
      this.model.Errors.ProgramMissing = false
    },

    resetAmountsOnPrgChanged() {
      this.model.InvoiceAmount = 0
      this.model.VATGSTAmount = 0
      this.model.InitialTotalAmount = 0
    },

    resetFields() {
      this.resetPOCombo()
      this.resetSupplierCombo()
      this.resetSupplierRefId()
      this.resetCurrencyCombo()

      this.model.Errors.SupplierZipCodeMissing = false
      this.model.Errors.PaymentTypeMissing = false
      this.model.Errors.DiscountMissing = false
      this.resetInvoiceAmountErrors()
    },

    resetPOCombo() {
      this.model.POid = 0
      this.model.PONumber = ''
      this.model.POCreatedDate = null

      this.purchaseOrder = null
      this.purchaseOrders = []
      this.originalPurchaseOrders = []

      this.model.Errors.POMissing = false

      EventBus.$emit(Eved.I2P.REMOVE_P2P_PO)
    },

    resetSupplierCombo() {
      EventBus.$emit(Eved.I2P.REMOVE_SUPPLIER)
    },

    resetSupplierRefId() {
      this.model.ReferenceNo = ''
    },

    resetCurrencyCombo() {
      this.model.CurrencyID = 0
      this.model.CurrencyCode = ''
      this.model.CurrencyName = ''

      this.currency = null
      this.currencies = []

      this.model.Errors.InvoiceCurrencyMissing = false
    },

    resetInvoiceAmountErrors() {
      this.model.Errors.InvoiceAmountMissing = false
      this.model.Errors.InvoiceAmountOutOfRange = false
      this.model.Errors.InvoiceAmountNegative = false
      this.model.Errors.InitialTotalAmountMissing = false
      this.model.Errors.InvoiceAmountExceededPOThreshold = false
    },

    changeToPreviousProgram() {
      this.showConfirmProgramSelected = false
      this.program = this.previousProgram
    },

    selectPaymentType(e) {
      this.model.PaymentTypeID = e.Key
      this.model.PaymentType = e.Value

      this.model.Errors.PaymentTypeMissing = false
    },

    selectDiscount(e) {
      this.updateDiscountAndDueDate(e.Key, e.Name, e.DaysNo)
    },

    removeDiscount(e) {
      if (e.Key) {
        this.updateDiscountAndDueDate(0, 'No Discount', this.settings.CompanySettings.DefaultDaysNo)
      }
    },

    updateDiscountAndDueDate(id, name, daysNo, skipRecalculatePO) {
      if (id === 0) daysNo = this.settings.CompanySettings.DefaultDaysNo

      this.model.DiscountPaymentTermID = id
      this.model.DiscountName = name

      this.$emit('discountSelected', {
        DiscountPaymentTermID: id,
        DiscountName: name,
        SkipRecalculatePO: skipRecalculatePO
      })

      // update Due Date
      if (!this.model.IsSameDayDeposit) {
        // Discount was deleted, use default payment terms from admin
        if ((daysNo || 0) === 0) {
          daysNo = this.settings.CompanySettings.DefaultDaysNo
        }
        if ((daysNo || 0) > 0) {
          this.settings.CompanySettings.DaysNo = daysNo
          this.paymentTermsDays = daysNo
        }
        if (!this.isInitSupplier) {
          this.updateDueDate(this.model.InvoiceDate, this.paymentTermsDays)
        }
      }

      this.model.Errors.DiscountMissing = false
    },

    async selectPurchaseOrder(poSelected) {
      this.selectedPO = poSelected

      // if program was not selected already, we need to prefill it
      if (this.model.ProgramID === 0 && this.program.Key === 0) {
        await this.populateProgramCombo(poSelected.Value.ProgramId, poSelected.Value.IsSavingsPO)
      } else {
        this.model.UseSavingsFields = poSelected.Value.IsSavingsPO
      }

      this.getPOSnapshotDetails(poSelected.Value.POId)

      this.model.POid = poSelected.Key
      this.model.PONumber = poSelected.Value.PONumber
      this.model.Errors.POMissing = false

      await this.getPurchaseOrderJSON(poSelected.Value.PONumber, poSelected.Value.POMasterId)
    },

    continueSelectPurchaseOrder() {
      // Populate Additional Data
      this.populateCurrencyandInvoiceAmount(this.selectedPO)
      this.populateSupplierCombo(this.selectedPO)
    },

    async getPurchaseOrderJSON(poNumber, poMasterId) {
      let url = this.model.UseSavingsFields
        ? api.GetSavingsDetails()
        : api.GetPurchaseOrderDetails()

      this.api.get(
          url, { params: {
            uniqueId: poNumber,
            userId: this.user.buyerUserID,
            getLastSent: true
          }}
        ).then(r => {
          if (r && r.data) {
            this.$emit(Eved.I2P.UPDATE_PO_MODEL, {
              PO: r.data,
              POMasterID: poMasterId
            })
          }
        }
      ).catch(e => console.warn(e))
    },

    getPOSnapshotDetails(poId) {
      this.api.forms.post(this.api.$.invoice.i2p.getPOSnapshotDetails, {
        poId: poId
      })
      .then(r => {
        if (r && r.data && r.data.Data) {
          var P2PSnapshotInfo = JSON.parse(r.data.Data)
          this.model.CurrencyCode = P2PSnapshotInfo.CurrencyCode
          EventBus.$emit(Eved.I2P.UPDATE_P2P_Snapshot, P2PSnapshotInfo)
        }
      })
      .catch(e => console.warn(e))
    },

    async populateProgramCombo(programId, isSavingsPO) {
      this.api.get(
          this.api.$.invoice.i2p.programDetails, { params: {
            programId: programId,
            invoiceId: this.getInvoiceId
          }}
        ).then(r => {
          if (r && r.data && r.data.Data) {
            var result = JSON.parse(r.data.Data)
            if (this.isP2PInvoice) {
              this.model.UseSavingsFields = isSavingsPO
              result.UseSavingsFields = isSavingsPO
            }

            this.processProgramAfterSelectPO(result)

            this.getPOS(true)
          }
        }
      ).catch(e => console.warn(e))
    },

    processProgramAfterSelectPO(result) {
      this.programDetails = JSON.parse(result.ProgramDetails)

      this.program = {
        Key: this.programDetails.ProgramID,
        Value: {
          ProgramName: he.decode(this.programDetails.ProgramName),
          InternalProgramId: this.programDetails.InternalProgramID
        }
      }

      this.setInitialProgramData(this.program)

      if (this.programDetails.UniqueId) {
        EventBus.$emit(Eved.I2P.PROGRAM_SELECTED, result)
      } else {
        alert('Program could not be found')
      }
    },

    populateSupplierCombo(poSelected) {
      this.api.forms.post(
        this.api.$.invoice.i2p.getSupplierFromAddSupplierButton,
        {
          supplier: {
            EmailAddress: poSelected.Value.SupplierEmail,
            InvoiceId: this.getInvoiceId
          }
        }
        ).then(r => {
          if (r && r.data && r.data.Data) {
            var response = JSON.parse(r.data.Data)

            this.populateOutSidesupplierData(response, poSelected)

            var info = {
              SupplierInfoVM: this.getSupplierInfoVM(response),
              VendorId: response.VendorId || 0,
              VendorUserID: response.VendorUserID || 0,
              VendorVCI: response.VendorVCI || response.VendorTempEONumber || 0,
              CardInfo: JSON.parse(response.SupplierCardInfo),
              InvoiceCurrencyCode: this.model.CurrencyCode
            }

            EventBus.$emit(Eved.I2P.ADDED_NEW_SUPPLIER, info)
          }
        }
      ).catch(e => console.warn(e))
    },

    async populateCurrencyandInvoiceAmount(poSelected) {
      await this.populateCurrency(poSelected)
      this.populateInvoiceAmount(poSelected)
    },

    populateCurrency(poSelected) {
      this.currency = {
        Key: poSelected.Value.CurrencyID,
        Value: poSelected.Value.CurrencyNameFormatted,
        Symbol: poSelected.Value.CurrencySymbol,
        DecimalPlaces: poSelected.Value.DecimalPlaces
      }

      this.selectCurrency(this.currency)
    },

    populateInvoiceAmount(poSelected) {
      if (this.isCreateInvoice()) {
        this.model.InvoiceAmount = poSelected.Value.NotInvoicedAmount
      }
      this.notInvoicedAmount = Number(poSelected.Value.NotInvoicedAmount)
      this.changeInvoiceAmount()
    },

    populateOutSidesupplierData(response, poSelected) {
      if (response.OutSideNewSupplier === 'Yes') {
        response.CompanyName = poSelected.Value.SupplierName
        response.SupplierContact = poSelected.Value.SupplierContactName
        response.Phone = poSelected.Value.SupplierPhoneNumber
        response.SupplierContactEmail = poSelected.Value.SupplierEmail
      }
      return response
    },

    getSupplierInfoVM(response) {
      return {
        SupplierName: response.CompanyName,
        SupplierID: response.SupplierIDCode,
        SupplierVatGstID: response.SupplierVatGstId,
        SupplierContactName: response.SupplierContact,
        EmailAddress: response.SupplierContactEmail,
        SupplierPhone: response.Phone,
        SupplierAddress1: response.Address,
        SupplierAddress2: response.Address2,
        SupplierCity: response.City,
        SupplierZIP: response.Zip,
        SupplierCountryID: response.CountryID,
        CountryName: response.CountryName,
        DiscountPaymentTermID: response.DiscountPaymentTermID,
        DiscountName: response.DiscountName,
        DiscountDaysNo: response.DiscountDaysNo,
        VendorType: response.VendorType,
        HasDefaultImmediatePayment: response.HasDefaultImmediatePayment,
        WithholdingTaxPercent: response.WithholdingTaxPercent,
        Currencies: response.Currencies,
        InvoiceCurrencyCode: response.InvoiceCurrencyCode
      }
    },

    selectCurrency(e) {
      this.model.CurrencyID = e.Key
      this.model.CurrencyCode = e.Value.indexOf('(') !== -1
        ? e.Value.split('(')[1].replace(')', '')
        : e.Value

      this.model.CurrencyName = e.Value

      this.model.Errors.InvoiceCurrencyMissing = false
      this.emitCurrencyEvent(this.model.CurrencyCode, e.Symbol, e.DecimalPlaces)
    },

    currencyInput(e) {
      if (e === null) {
        this.emitCurrencyEvent('', '', 2)
      }
    },

    emitCurrencyEvent(code, symbol, decimalPlaces) {
      this.$emit(Eved.I2P.CURRENCY_SELECTED, {
        code: code,
        symbol: symbol,
        decimalPlaces: decimalPlaces
      })
      EventBus.$emit(Eved.I2P.CURRENCY_SELECTED, {
        code: code,
        symbol: symbol,
        decimalPlaces: decimalPlaces
      })
    },

    parseISODateString(dateString) {
      if (typeof dateString === 'string' && dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [year, month, day] = dateString.split('-').map(Number)
        return new Date(year, month - 1, day)
      }
      return dateString
    },

    parseDate(dateString, fieldType = 'invoiceDate') {
      if (!/\d{4}/.test(dateString)) {
        if (fieldType === 'invoiceDate') {
          this.model.Errors.InvoiceDateIncomplete = true
        } else if (fieldType === 'dueDate') {
          this.model.Errors.DueDateIncomplete = true
        }
        return null
      }
      if (fieldType === 'invoiceDate') {
        this.model.Errors.InvoiceDateIncomplete = false
      } else if (fieldType === 'dueDate') {
        this.model.Errors.DueDateIncomplete = false
      }
      const date = new Date(dateString)
      return this.setDate(date)
    },

    selectInvoiceDate(value) {
      value = this.parseISODateString(value)
      if (value instanceof Date && (value.getFullYear() < 2000 || value.getFullYear() > 2100)) {
        this.model.Errors.InvoiceDateIncomplete = true
        this.invoiceDate = null
        return
      }
      if (typeof value === 'string') {
        value = this.parseDate(value, 'invoiceDate')
        if (!value) {
          this.invoiceDate = null
          return
        }
      }
      if (value) {
        this.model.InvoiceDate = this.setDate(value)
        this.updateDueDate(value, this.paymentTermsDays)

        this.rushDays = {}
        this.model.HasRushPayment = false
        this.model.RushPaymentReason = ''
        if (this.model.IsSameDayDeposit) {
          this.checkRushPayment()
          this.updateDuedDateIfInvoiceDateIsInThePast(value)
        }
      }
      this.model.Errors.InvoiceDateMissing = false
    },

    updateDuedDateIfInvoiceDateIsInThePast(value) {
      var dueDateValue = this.setImmediateDueDateValue(value)
      dueDateValue && this.updateDueDate(dueDateValue, this.paymentTermsDays)
    },

    setImmediateDueDateValue(value) {
      if (value) {
        if (this.model.IsSameDayDeposit && this.selectedDateIsInThePast(value)) {
          return new Date()
        }
      }

      return null
    },

    selectedDateIsInThePast(date) {
      var now = new Date()
      var selectedDate = new Date(date)

      now.setHours(0, 0, 0, 0)
      selectedDate.setHours(0, 0, 0, 0)

      if (selectedDate.getTime() < now.getTime()) {
        return true
      }

      return false
    },

    getDatesDifferenceInDays(startDate, endDate) {
      // create object from string
      if (typeof startDate === 'string') {
        startDate = new Date(startDate)
      } else {
        startDate = this.setDate(startDate)
      }
      if (typeof endDate === 'string') {
        endDate = new Date(endDate)
      } else {
        endDate = this.setDate(endDate)
      }

      // Date without time component
      if (startDate != null && endDate != null) {
        startDate = new Date(startDate.toDateString())
        endDate = new Date(endDate.toDateString())

        // return difference in days
        let diffTime = Math.abs(endDate - startDate)

        // fix daylight savings time difference
        if (startDate.getTimezoneOffset() < 0) {
          // GMT+0200 - rounding is not necessary
          return parseInt(diffTime / (1000 * 60 * 60 * 24))
        } else if (startDate.getTimezoneOffset() > 0) {
          // GMT-0800
          return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
        }
      }

      return 0
    },

    selectDueDate(value) {
      value = this.parseISODateString(value)
      if (value instanceof Date && (value.getFullYear() < 2000 || value.getFullYear() > 2100)) {
        this.model.Errors.DueDateIncomplete = true
        this.dueDate = null
        return
      }
      if (typeof value === 'string') {
        value = this.parseDate(value, 'dueDate')
        if (!value) {
          this.dueDate = null
          return
        }
      }

      if (this.model.DiscountPaymentTermID > 0 &&
        this.getDatesDifferenceInDays(this.model.InvoiceDate, value) > this.paymentTermsDays) {
        this.dueDateToValidate = value
        value = this.model.DueDate
        this.showDiscountDueDateValidationError = true
      }

      if (value) {
        this.dueDate = value
        this.model.DueDate = value

        !this.model.isEditInit && this.checkRushPayment()
      }

      this.model.Errors.DueDateMissing = false
      this.model.Errors.DueDateIncomplete = false
    },

    checkRushPayment() {
      let initialDueDate = this.model.DueDate
      let rushDays = this.getRushPaymentDays()

      if (rushDays && (rushDays.RushPaymentTermsDays < rushDays.StandardRushPaymentDays)) {
        let rushPaymentModel = this.mapRushPaymentInfo(rushDays, initialDueDate)
        this.openRequestRushPaymentDialog(rushPaymentModel)
      } else {
        this.model.HasRushPayment = false
      }
    },

    mapRushPaymentInfo(rushDays, initialDueDate) {
      return {
        RushPaymentTermsDays: rushDays.RushPaymentTermsDays,
        StandardRushPaymentDays: rushDays.StandardRushPaymentDays,
        DaysEarlier: rushDays.DaysEarlier,
        HasDiscountedPaymentTerm: rushDays.HasDiscountedPaymentTerm,
        Reason: '',
        InitialDueDate: initialDueDate,
        IsSameDayDeposit: this.model.IsSameDayDeposit
      }
    },

    getRushPaymentDays() {
      this.rushDays.RushPaymentTermsDays = Math.round(Math.abs((new Date(this.model.DueDate).getTime() - new Date(this.model.InvoiceDate).getTime()) / this.oneDay))
      this.rushDays.StandardRushPaymentDays = this.paymentTermsDays
      this.rushDays.DaysEarlier = Math.abs(this.rushDays.StandardRushPaymentDays - this.rushDays.RushPaymentTermsDays)
      this.rushDays.HasDiscountedPaymentTerm = this.discount && this.discount.Key > 0

      return this.rushDays
    },

    async getProgramDetails(programId) {
      if (programId > 0) {
        // SPRT-18874: drop the previous program's verdict before asking about this one. The .catch below
        // swallows a transient failure without ever reaching processProgramDetails, so without this the
        // flag set by an earlier cancelled program would stick and block save/submit on a valid one.
        this.model.Errors.ProgramCancelled = false

        this.api.get(
          this.api.$.invoice.i2p.programDetails, { params: {
            programId: programId,
            useHighLevelAllocation: this.useHighLevelAllocation,
            invoiceId: this.getInvoiceId
          }}
        ).then(r => {
          if (r && r.data && r.data.Data) {
            var result = JSON.parse(r.data.Data)
            this.processProgramDetails(result)
            this.setAllocationSectionModel(programId)
          }
        }
        ).catch(e => console.warn(e))
      }
    },

    async processProgramDetails(result) {
      // SPRT-18874: refuse a cancelled program the moment it is picked, instead of letting the user fill
      // the whole form and fail at submit. Covers an existing invoice too — this picker has no :disabled
      // binding, so it stays open on edit, and moving a saved invoice onto a cancelled program is what the
      // backend guard refuses. The backend flags only a program the invoice is not already on, so loading
      // an existing invoice whose program was cancelled after the fact is untouched — it stays editable.
      this.model.Errors.ProgramCancelled = result.IsProgramCancelled === true
      if (this.model.Errors.ProgramCancelled) {
        this.showCancelledProgramError()
      }

      await this.setWorkflowType(result)

      this.settings.CompanySettings.AllowSameDayDeposit = result.AllowSameDayDeposit || false
      this.settings.CompanySettings.RequireAdditionalInvoiceConfirmation = result.RequireAdditionalInvoiceConfirmation || false
      this.settings.CompanySettings.AllowEditItem = result.AllowEditItem || false
      this.settings.CompanySettings.ExcludeTaxesFromPOThreshold = result.ExcludeTaxesFromPOThreshold || false
      this.settings.CompanySettings.AllowInvoiceToExceedPOQty = result.AllowInvoiceToExceedPOQty || false
      this.settings.CompanySettings.AllocateProcessingFeeToEveryCostCenter = result.AllocateProcessingFeeToEveryCostCenter || false

      this.model.IsRequiredSupplierZipCode = result.IsRequiredSupplierZipCode || false
      this.doAdditionalProcessing(result)

      this.programDetails = JSON.parse(result.ProgramDetails)
      this.model.DivisionID = this.programDetails.DivisionID
      this.model.BusinessUnitID = this.programDetails.BusinessUnitID
      this.model.DivisionName = result.DivisionName
      this.programCurrencyCode = this.programDetails.CurrencyCode
      this.cFields++

      this.loadRemainingProgramBudget(this.programDetails.ProgramID)

      if (this.programDetails.UniqueId) {
        EventBus.$emit(Eved.I2P.PROGRAM_SELECTED, result)
      }
    },

    // SPRT-18874
    // Finite timeout, unlike the app's usual `timeout: 0` error alerts. This one goes STALE: switching from
    // a cancelled program to a valid one clears the field error, but a never-closing banner would keep
    // telling the user the program is cancelled until they dismissed it by hand.
    //
    // `heading` is what the notification store dedupes `alert: true` entries by
    // (core/components/mdNotifications/install.js). Without one this banner collided with every other alert
    // on the screen — including the never-closing save error — and whichever was up first swallowed the
    // rest. Same string as index.vue's load-path copy on purpose: those two ARE the same refusal and should
    // dedupe, and they are distinct from 'Invoice not saved'.
    showCancelledProgramError() {
      global.app.$notifications.notify({
        alert: true,
        type: 'plain',
        icon: 'exclamation-circle',
        placement: { from: 'top', align: 'center' },
        heading: 'Cancelled program',
        timeout: 10000,
        message: programConstants.cancelledProgramMessage
      })
    },

    async loadRemainingProgramBudget(programId) {
      if (+programId > 0) {
        this.api.forms.post(
          this.api.$.invoice.i2p.remainingBudget,
          {
            programId: programId
          }
          ).then(r => {
            if (r && r.data) {
              this.programBudgetData = [[
                this.model.ProgramName,
                r.data.RevisedBudget,
                r.data.BudgetBalance, // Remaining Budget
                r.data.TotalPO, // POs/Invoices
                r.data.TotalExpense, // Expenses
                r.data.POTotalLessVatGst,
                r.data.ExpenseTotalLessVatGst,
                r.data.IncludeExpenseInBudget,
                r.data.ExcludeVATFromBudget
              ],
              {
                'POsOrInvoicesLabel': this.isP2PInvoice ? 'POs' : 'Invoices'
              }]
              this.excludeVATFromBudget = r.data.ExcludeVATFromBudget
            }
          })
      }
    },

    doAdditionalProcessing(result) {
      result.workflowChanged = result.InvoiceWorkflowStr !== this.previousInvoiceWorkflow

      if (this.isP2PInvoice || result.workflowChanged) {
        this.resetFields()
      }

      if (this.isP2PInvoice) {
        this.getPOS(true)
      }
    },

    setWorkflowType(result) {
      if (result && result.InvoiceWorkflowStr) {
        this.model.InvoiceWorkflow = utils.copy(result.InvoiceWorkflowStr)
      }
    },

    setAllocationSectionModel(programId) {
      if (this.showNeddedFieldsForScanning) {
        this.api.get(
          api.GetAllocations(), {
            params: {
              programId: programId
            }
          })
          .then(response => {
            var data = response.data
            EventBus.$emit(Eved.I2P.UPDATE_ALLOCATION_MODEL, data)

            if (this.model.scanAllocationOption || this.model.hasMultipleAllocation) {
              EventBus.$emit(Eved.I2P.INIT_ALLOCATION_MODEL, {
                type: this.model.allocationType,
                selectedOption: this.model.scanAllocationOption,
                hasMultipleAllocation: this.model.hasMultipleAllocation
              })
            }
          })
      }
    },

    fetchPaymentTypes() {
      this.paymentTypes.length || this.api.forms.post(
        this.api.$.invoice.i2p.paymentTypes,
        {
          q: '',
          divisionID: this.model.DivisionID
        }
      ).then(r => {
        if (r && r.data && r.data.Data) {
          this.paymentTypes = r.data.Data
        }
      }
      ).catch(e => console.warn(e))
    },

    fetchDiscounts() {
      this.discounts.length > 1 || this.api.forms.post(
        this.api.$.invoice.i2p.discounts,
        {
          q: '',
          invoiceId: this.getInvoiceId
        }
      ).then(r => {
        if (r && r.data && r.data.Data) {
          this.discounts = r.data.Data
        }
      }
      ).catch(e => console.warn(e))
    },

    //
    fetchCurrencies() {
      this.currencies.length || this.api.forms.post(
        this.api.$.invoice.i2p.currencies,
        {
          q: '',
          programId: this.model.ProgramID,
          invoiceId: this.getInvoiceId
        }
      ).then(r => {
        if (r && r.data && r.data.Data) {
          this.currencies = r.data.Data

          if (this.currencies && this.currencies.length === 1) {
            // select first
            this.selectCurrency(this.currencies[0])
            this.mapSelectedCurrency()
          }
        }
      }
      ).catch(e => console.warn(e))
    },

    addNewSupplierClickHandler() {
      if (this.settings.CompanySettings.EditingInvoiceScan) this._openAddEditSupplierModalOldDialog('add')
      else this._openInviteSupplierModalDialog('add')
    },

    _openInviteSupplierModalDialog(operation) {
      var ComponentClass = Vue.extend(InviteSupplier)
      var instance = new ComponentClass({
        propsData: {
          type: 'primary',
          model: null,
          invoiceId: this.getInvoiceId,
          eventHub: eventHub,
          operation: operation
        }
      })
      instance.$slots.default = []
      instance.$mount()
      this.$refs.addNewSupplierDialogContainer.appendChild(instance.$el)
    },

    _openAddEditSupplierModalOldDialog(operation) {
      var ComponentClass = Vue.extend(AddEditSupplierOld)
      var instance = new ComponentClass({
        propsData: {
          type: 'primary',
          model: null,
          invoiceId: this.getInvoiceId,
          eventHub: eventHub,
          operation: operation
        }
      })
      instance.$slots.default = []
      instance.$mount()
      this.$refs.addNewSupplierDialogContainer.appendChild(instance.$el)
    },

    setDueDate(invoiceDate, daysNo) {
      let dueDate = this.setDate(invoiceDate)
      dueDate.setDate(dueDate.getDate() + daysNo)
      return dueDate
    },

    updateDueDateOnSelectSupplier(supplierId) {
      this.api.forms.post(
      this.api.$.invoice.i2p.getInvoiceDueDate,
        {
          supplierId: supplierId,
          invoiceId: this.getInvoiceId
        }
      ).then(r => {
        if (r && r.data && r.data.Data) {
          var result = JSON.parse(r.data.Data)
          if (this.model.DiscountPaymentTermID > 0) {
            this.settings.CompanySettings.DefaultDaysNo = result
            this.paymentTermsDays = this.settings.CompanySettings.DaysNo
          } else {
            this.paymentTermsDays = result
          }
          if (!this.isCreateInvoice() && this.model.isEditInit) {
            this.getRushPaymentDays()
          } else {
            this.updateDueDate(this.model.InvoiceDate, this.paymentTermsDays)
          }
          this.model.isEditInit = false
        }
      }
      ).catch(e => console.warn(e))
    },

    updateDueDate(invoiceDate, days) {
      if (invoiceDate) {
        if (this.model.IsSameDayDeposit) {
          // https://evedllc.atlassian.net/browse/WORKFLOW-1223
          // Match Due Date to Invoice Date for Immediate Payment
          days = 0
        }
        let dueDate = this.setDueDate(invoiceDate, days)
        this.dueDate = dueDate
        this.model.DueDate = dueDate
        this.model.HasRushPayment = false
      }
      this.model.Errors.DueDateMissing = false
      this.model.Errors.DueDateIncomplete = false
    },

    openRequestRushPaymentDialog(rushPaymentModel) {
      var ComponentClass = Vue.extend(RequestRushPayment)
      var instance = new ComponentClass({
        propsData: {
          type: 'primary',
          model: rushPaymentModel,
          eventHub: eventHub
        }
      })
      instance.$slots.default = []
      instance.$mount()
      this.$refs.requestRushPaymentDialogContainer && this.$refs.requestRushPaymentDialogContainer.appendChild(instance.$el)
    },

    onCloseRushPaymentDialog(e) {
      if (this.model.IsSameDayDeposit) {
        // reset reset the payment type => reset invoice date and due date
        this.resetPaymentTypeCombo()
        this.resetPaymentTermCombo()
        this.resetSameDayDepositOption()
        this.resetInvoiceDate()
        this.resetDueDate()
      } else {
        this.updateDueDate(this.model.InvoiceDate, this.paymentTermsDays)
      }

      this.model.HasRushPayment = false
      this.model.RushPaymentReason = ''
    },

    resetPaymentTypeCombo() {
      this.paymentType = {
        Key: 0,
        Value: ''
      }
      this.model.PaymentTypeID = 0
      this.model.PaymentType = ''
    },

    resetPaymentTermCombo() {
      this.paymentTerm = {
        Key: 0,
        Value: ''
      }
      this.model.DiscountPaymentTermID = 0
      this.model.DiscountName = ''
    },

    resetSameDayDepositOption(value) {
      this.sameDayDepositOption[0].status = value
      this.model.IsSameDayDeposit = value
    },

    resetInvoiceDate() {
      this.invoiceDate = null
      this.model.InvoiceDate = null
    },

    resetDueDate() {
      // let dueDate = this.setDueDate(null)
      this.dueDate = null
      this.model.DueDate = null
    },

    onSaveRushPaymentDialog(e) {
      this.model.RushPaymentReason = e.data
      this.model.HasRushPayment = true
    },

    comingFromProgramDashboard() {
      return this.$route.query.from &&
        this.$route.query.from.toLowerCase().trim() === 'programdashboard'
    },

    comingFromProgramPOList() {
      return this.$route.query.from &&
        this.$route.query.from.toLowerCase().trim() === 'programsentpos'
    },

    invoiceIsSaved() {
      return this.model.InvoiceIsSaved || false
    },

    getProgramLabel(option) {
      return option && option.Value && option.Value.ProgramName ? he.decode(option.Value.ProgramName) : ''
    },

    getPOLabel(option) {
      return option && option.Value && option.Value.PONumber ? option.Value.PONumber : ''
    },

    changeInvoiceAmount() {
      this.resetInvoiceAmountErrors()

      EventBus.$emit(Eved.I2P.INVOICE_AMOUNT_CHANGED, {
        amount: this.model.InvoiceAmount,
        notInvoicedAmount: Number(this.notInvoicedAmount)
      })
      // In index.vue InvoiceAmount variable is updated on INVOICE_AMOUNT_CHANGED event.
      // With reactiveness, InvoiceAmount gets updated in HighAllocationSection.vue component (there is a watch on this variable)
      // The invoiceAmount() watch from HighAllocationSection.vue will update all allocations and
      // it will further call: EventBus.$emit(Eved.I2P.CHANGE_ALLOCATION, payload)
    },
    changeInitialTotalAmount() {
      this.resetInvoiceAmountErrors()
      EventBus.$emit(Eved.I2P.INVOICE_INITIAL_TOTAL_AMOUNT_CHANGED, {
        amount: this.model.InitialTotalAmount
      })
      EventBus.$emit(Events.I2P.UPDATE_SNAPSHOT, {
        total: +this.model.InitialTotalAmount,
        totalVATGST: +this.model.VATGSTAmount,
        programCurrencyCode: this.programCurrencyCode
      })
    },

    changeVatGSTAmount() {
      EventBus.$emit(Eved.I2P.VAT_AMOUNT_CHANGED, {
        vatgstAmount: this.model.VATGSTAmount
      })
      // In index.vue VATAmount variable is updated on INVOICE_AMOUNT_CHANGED event.
      // With reactiveness, VATAmount gets updated in HighAllocationSection.vue component (there is a watch on this variable)
      // The vatAmount() watch from HighAllocationSection.vue will update all allocations and
      // it will further call: EventBus.$emit(Eved.I2P.CHANGE_ALLOCATION, payload)
      EventBus.$emit(Events.I2P.UPDATE_SNAPSHOT, {
        total: +this.model.InitialTotalAmount,
        totalVATGST: +this.model.VATGSTAmount,
        programCurrencyCode: this.programCurrencyCode
      })
    },

    async changeSameDaySetting(e) {
      this.$emit('changeSameDaySetting', e)
      await this.resetSameDayDepositOption(e.status)

      if (!e.status) {
        this.model.Errors.InvoiceAmountNegative = false
      }

      this.updateDueDate(this.model.InvoiceDate, this.paymentTermsDays)

      if (this.model.InvoiceDate) {
        this.checkRushPayment()
        this.updateDuedDateIfInvoiceDateIsInThePast(this.model.InvoiceDate)
      }
    },

    async changeReimbursementSetting(e) {
      this.$emit('changeReimbursementSetting', e)
    },

    onSelectAllocationType(e) {
      this.model.IsAllocationSelected = e.isAllocationSelected
      this.model.HasAllocationSection = e.hasAllocationSection
      this.model.HasAllocationForScan = e.hasAllocationForScan
      this.model.Errors.AllocationTypeMissing = false
      this.model.Errors.AllocationMissing = false
    },

    onCustomFieldsLoad() {
      this.customFieldsLoaded = true
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.details-text {
  font-size: 12px;
  color: #51226c;
}

.additional-text {
  font-size: smaller;
  font-weight: 400;
  font-style: italic;
  padding-left: 22px;
}

.additional-text-no-padding {
  font-size: smaller;
  font-weight: 400;
  font-style: italic;
}

.text-red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/I2P/InvoiceInformation.vue